import { useEffect } from 'react';

export type Hotkey = { key: string; ctrl?: boolean; shift?: boolean; alt?: boolean; run: (e: KeyboardEvent) => void; allowInInput?: boolean };

/** Global hotkeys. `ctrl` means Ctrl on Windows/Linux and Cmd on macOS. */
export function useHotkeys(keys: Hotkey[]): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const mod = navigator.platform.includes('Mac') ? e.metaKey : e.ctrlKey;
      const inInput = (e.target as HTMLElement | null)?.closest('input, textarea, .cm-editor, [contenteditable]') !== null;
      for (const k of keys) {
        if (e.key.toLowerCase() !== k.key.toLowerCase()) continue;
        if (!!k.ctrl !== mod) continue;
        if (!!k.shift !== e.shiftKey) continue;
        if (!!k.alt !== e.altKey) continue;
        if (inInput && !k.allowInInput) continue;
        e.preventDefault();
        k.run(e);
        return;
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [keys]);
}
